import { cloneDeep } from "lodash";
import { useCallback } from "react";
import { useRecoilState } from "recoil";
import { ModalAtom } from "../atoms/modalAtoms";

export const useModals = () => {
    const [modalState, setModal] = useRecoilState(ModalAtom);

    const setModalState = useCallback(
        (fn) => {
            // const data = cloneDeep(modalState);
            setModal((p) => fn(cloneDeep(p)));
        },
        [setModal]
    );
    const showModal = useCallback(
        (name, data) => {
            setModalState((p) => {
                p[name].show = true;
                p[name].data = data;
                return p;
            });
        },
        [setModalState]
    );
    const closeModal = useCallback(
        (name) => {
            setModalState((p) => {
                p[name].show = false;
                p[name].data = null;
                return p;
            });
        },
        [setModalState]
    );

    return { showModal, modalState, closeModal };
};
